export default __webpack_public_path__ + "static/media/headshot.533cc3ae.jpg";